<section class="users-edit">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- Nav-tabs -->
              <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs justify-content-left">
                <li [ngbNavItem]="1">
                  <ng-template ngbNavContent>
                    <!-- Account content starts -->
                    <div class="mt-2" id="account">
                      <!-- Media object starts -->
                      <!-- <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-2.png" alt="user edit avatar"
                          class="users-avatar-shadow avatar mr-3 rounded-circle" height="64" width="64">
                        <div class="media-body">
                          <h4>Avatar</h4>
                          <div class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                            <button class="btn btn-sm btn-primary mb-1 mb-sm-0">Change</button>
                            <button class="btn btn-sm bg-light-secondary ml-sm-2">Reset</button>
                          </div>
                        </div>
                      </div> -->
                      <!-- Media object ends -->
  
                      <!-- Account form starts -->
                      <form >
                        <div class="row">
                          <div class="col-md">
                            <fieldset class="form-group">
                              <label for="name">Name</label>
                              <input type="text" class="form-control"   [(ngModel)]="discountData.name" [ngModelOptions]="{standalone: true}" id="name"  placeholder="Enter name" #name>
                            </fieldset>
                            <fieldset class="form-group">
                              <label for="categary">Discount Type</label>
                              <input type="text" class="form-control"   [(ngModel)]="discountData.discount_type" [ngModelOptions]="{standalone: true}" id="discount_type"  placeholder="Enter discount type" #discount_type> 
                            </fieldset>  
                            <fieldset class="form-group">
                                <label for="categary">Amount</label>
                                <input type="text" class="form-control"   [(ngModel)]="discountData.amount" [ngModelOptions]="{standalone: true}" id="amount"  placeholder="Enter amount" #amount>
                            </fieldset>  
                          </div>
                          <div class="col-md">
                            <fieldset class="form-group">
                              <label for="categary">Notes</label>
                              <textarea id="hidden-label-form-6" rows="3"[(ngModel)]="discountData.notes" [ngModelOptions]="{standalone: true}" class="form-control " name="comment2"  placeholder="Enter notes "#notes></textarea>
                            </fieldset> 
                            <fieldset class="form-group">
                              <label for="categary">Admin Notes</label>
                              <textarea id="hidden-label-form-6" rows="3"[(ngModel)]="discountData.admin_notes" [ngModelOptions]="{standalone: true}" class="form-control " name="comment2"  placeholder="Enter admin notes "#admin_notes></textarea>
                            </fieldset> 
                          </div>
                          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                            <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
                            (click)="discountUpdate()">Submit</button>
                            <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                          </div>
                         
                        </div>
                       
                      </form>
                      <!-- Account form ends -->
                    </div>
                    <!-- Account content ends -->
                  </ng-template>
                </li>
            
              </ul>
              <div class="tab-content">
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  